export default __webpack_public_path__ + "static/media/41.f7de8f6b.jpg";